import {
  Wallet,
  ShieldCheck,
  Zap,
  Wrench,
  Wifi,
  Headphones,
  Plane,
  Home,
  PawPrint,
  TrendingUp,
  Umbrella,
  Sun,
  Car,
  Tag,
  type LucideIcon,
} from "lucide-react";

export interface AffiliateTheme {
  /** Kort dansk kategori-label vist som badge */
  label: string;
  /** Lucide-ikon-komponent */
  icon: LucideIcon;
  /** HSL-værdier uden hsl() wrapper — bruges via CSS-variabel */
  accentHsl: string;
  /** Blødere baggrund til ikonflade (samme farve, lavere mætning) */
  softHsl: string;
}

const THEMES: Record<string, AffiliateTheme> = {
  finansiering: {
    label: "Finansiering",
    icon: Wallet,
    accentHsl: "152 65% 36%",
    softHsl: "152 55% 92%",
  },
  "erhvervslån": {
    label: "Erhvervslån",
    icon: Wallet,
    accentHsl: "152 55% 30%",
    softHsl: "152 45% 92%",
  },
  forsikring: {
    label: "Forsikring",
    icon: ShieldCheck,
    accentHsl: "212 78% 45%",
    softHsl: "212 70% 93%",
  },
  rejseforsikring: {
    label: "Rejseforsikring",
    icon: Umbrella,
    accentHsl: "200 80% 42%",
    softHsl: "200 70% 93%",
  },
  stroem: {
    label: "Strøm & el",
    icon: Zap,
    accentHsl: "42 92% 45%",
    softHsl: "48 92% 92%",
  },
  solceller: {
    label: "Solceller",
    icon: Sun,
    accentHsl: "36 95% 48%",
    softHsl: "42 95% 92%",
  },
  daek: {
    label: "Dæk",
    icon: Car,
    accentHsl: "22 85% 48%",
    softHsl: "22 80% 93%",
  },
  reservedele: {
    label: "Reservedele",
    icon: Wrench,
    accentHsl: "18 78% 45%",
    softHsl: "18 75% 93%",
  },
  internet: {
    label: "Internet",
    icon: Wifi,
    accentHsl: "232 68% 52%",
    softHsl: "232 65% 94%",
  },
  mobilabonnement: {
    label: "Mobil",
    icon: Wifi,
    accentHsl: "244 65% 55%",
    softHsl: "244 60% 94%",
  },
  lydboeger: {
    label: "Lydbøger",
    icon: Headphones,
    accentHsl: "268 60% 52%",
    softHsl: "268 55% 94%",
  },
  rejser: {
    label: "Rejser",
    icon: Plane,
    accentHsl: "188 72% 42%",
    softHsl: "188 65% 92%",
  },
  biludlejning: {
    label: "Biludlejning",
    icon: Car,
    accentHsl: "192 70% 40%",
    softHsl: "192 65% 92%",
  },
  boligindretning: {
    label: "Bolig",
    icon: Home,
    accentHsl: "338 68% 55%",
    softHsl: "338 65% 95%",
  },
  kaeledyr: {
    label: "Kæledyr",
    icon: PawPrint,
    accentHsl: "28 55% 42%",
    softHsl: "28 50% 93%",
  },
  investering: {
    label: "Investering",
    icon: TrendingUp,
    accentHsl: "160 68% 36%",
    softHsl: "160 60% 92%",
  },
  "a-kasse": {
    label: "A-kasse",
    icon: Umbrella,
    accentHsl: "218 70% 48%",
    softHsl: "218 65% 94%",
  },
};

const FALLBACK: AffiliateTheme = {
  label: "Partner",
  icon: Tag,
  accentHsl: "222 47% 40%",
  softHsl: "222 45% 94%",
};

export function getAffiliateTheme(category?: string | null): AffiliateTheme {
  if (!category) return FALLBACK;
  return THEMES[category.toLowerCase()] ?? FALLBACK;
}
